import { render, staticRenderFns } from "./veSbzcJzwBuildcate.vue?vue&type=template&id=4c90c502&scoped=true"
import script from "./veSbzcJzwBuildcate.vue?vue&type=script&lang=js"
export * from "./veSbzcJzwBuildcate.vue?vue&type=script&lang=js"
import style0 from "./veSbzcJzwBuildcate.vue?vue&type=style&index=0&id=4c90c502&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c90c502",
  null
  
)

export default component.exports